/**
 * List-row card for an upcoming live session.
 */
import React from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { VButton, VText } from "form";
import BThumb from "./BThumb";
import { getFormatDate, getShortTime } from "utils/date";

/**
 * Live-session row with tutor, schedule, and a Jitsi join link.
 *
 * @param {{ session: Object, disabled?: boolean }} props
 */
const BZoomListItem = (props) => {
  const { session, disabled = false } = props;

  const { t, i18n } = useTranslation("common");

  return (
    <Box className="flex flex-row justify-between rounded border border-solid border-gray-200 dark:border-gray-500 pr-4">
      <Box className="flex flex-row gap-4 items-center">
        <BThumb src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/lms/video_1.png`} error="" className="aspect-[9/5] rounded-md h-32 w-56 flex-shrink-0" />
        <Box className="py-4 flex flex-col w-full gap-0.5">
          <VText className="text-xl text-limit-1">{session.topic || "-"}</VText>
          <VText className="text-limit-1">{session.tutor_name}</VText>

          <VText color="secondary" className="flex items-center text-sm text-limit-1">
            <Icon icon="lucide:clock-9" className="flex-shrink-0" />
            &nbsp;
            {getFormatDate(session.start_time, i18n.language)} - {getShortTime(session.start_time)}
          </VText>
        </Box>
      </Box>
      <Box className="flex flex-col justify-center w-3/12">
        {disabled ? (
          <VButton variant="contained" color="primary" className="w-full normal-case mt-4" disabled>
            {t("Join")}
          </VButton>
        ) : (
          <a href={`${process.env.REACT_APP_JITSI_DOMAIN}/start/${process.env.REACT_APP_SITE_NAME}/${session.room}`} className="no-underline w-full normal-case mt-4" rel="noreferrer" target="_blank">
            <VButton variant="contained" color="primary" className="w-full normal-case">
              {t("Join")}
            </VButton>
          </a>
        )}
      </Box>
    </Box>
  );
};

BZoomListItem.propTypes = {
  session: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default BZoomListItem;
